export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE_NUMBER = 1;
export interface Pagination {
  pageNumber: number;
  pageSize: number;
}
